import React from 'react';
import './BlockTitle.less';

export const BlockTitle = ({text, isLarge = false, isNonScalable}) => {
	if (isLarge) {
		return <h2 className={`block-title block-title--large ${
			isNonScalable ? 'block-title--non-scalable' : ''
		}`}>{text}</h2>
	} else {
		return <h3 className={`block-title ${
			isNonScalable ? 'block-title--non-scalable' : ''
		}`}>{text}</h3>
	}
};
